/* eslint-disable max-len */

/* eslint-disable @typescript-eslint/no-shadow */
import { StyledTransition } from '@douyinfe/semi-animation-react';
import React from 'react';
import { cssClasses } from '@douyinfe/semi-foundation/lib/es/tooltip/constants';
import getMotionObjFromProps from '@douyinfe/semi-foundation/lib/es/utils/getMotionObjFromProps';
const enterCls = "".concat(cssClasses.PREFIX, "-bounceIn");
const leaveCls = "".concat(cssClasses.PREFIX, "-zoomOut");

const TooltipTransition = function () {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    children
  } = props;
  const motion = getMotionObjFromProps(props); //  add fillMode forwards to fix issue 715, tooltip close will flashing under react 18

  return /*#__PURE__*/React.createElement(StyledTransition, Object.assign({}, props, {
    enter: enterCls,
    leave: leaveCls,
    duration: '100ms'
  }, motion, {
    fillMode: 'forwards'
  }), typeof children === 'function' ? _ref => {
    let {
      animateCls,
      animateEvents,
      animateStyle
    } = _ref;
    return children({
      animateCls,
      animateEvents,
      animateStyle
    });
  } : children);
};

export default TooltipTransition;